import { render } from "./px-responsive-bitmap.vue?vue&type=template&id=cf65a060&ts=true"
import script from "./px-responsive-bitmap.vue?vue&type=script&lang=ts"
export * from "./px-responsive-bitmap.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__